// extracted by mini-css-extract-plugin
module.exports =  {"code-widget__loading":"CodeSkeleton-module__code-widget__loading___IgHut","code-widget__loading__lines":"CodeSkeleton-module__code-widget__loading__lines___fOHU3"};